import { useEffect } from 'react';

// True si el error es una cancelación de request (AbortController), no un fallo real.
export const isCanceled = (e) =>
  e?.name === 'CanceledError' || e?.code === 'ERR_CANCELED' || e?.name === 'AbortError';

/**
 * Ejecuta `loader(signal)` al montar (y cuando cambian `deps`), abortando la
 * petición en vuelo al desmontar o al re-ejecutarse. Evita peticiones huérfanas
 * que saturan el pool de conexiones del navegador durante la navegación rápida.
 */
export function useAbortableLoad(loader, deps = []) {
  useEffect(() => {
    const controller = new AbortController();
    loader(controller.signal);
    return () => controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
